import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollContributionDetail  {
    _originalTypeClassName = "zERP.BO.PayrollContributionDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollContributionDetail.translate = translateService;
}
this.Salaries = [];
this.Id = null;
this.EmployeeContribution = null;
this.EmployerContribution = null;
this.EmployeeRate = null;
this.EmployerRate = null;
this.EmployeeAmount = null;
this.EmployerAmount = null;
this.EmployeeSubsidy = null;
this.EmployerSubsidy = null;
this.EmployeeSubsidyRate = null;
this.EmployerSubsidyRate = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
EmployeeContribution:any;
EmployerContribution:any;
EmployeeRate:any;
EmployerRate:any;
EmployeeAmount:any;
EmployerAmount:any;
EmployeeSubsidy:any;
EmployerSubsidy:any;
EmployeeSubsidyRate:any;
EmployerSubsidyRate:any;
Rule:any;
SalaryType:any;
Salaries:any;
static setRule = ($this, value) => {
var oldValue = $this.Rule;
$this.Rule = value;
if (value != null) {
}
}
static setSalaryType = ($this, value) => {
var oldValue = $this.SalaryType;
$this.SalaryType = value;
if (value != null) {
}
}
static setSalaries = ($this, items) => {
                if (items == null) items = [];
                if ($this.Salaries == null) $this.Salaries = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Salaries.length > 0) {
                    Domain.PayrollContributionDetail.removeSalaries($this, $this.Salaries[0]);
                }

                Domain.PayrollContributionDetail.addManySalaries($this, copyItems);
            }
static addManySalaries = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollContributionDetail.addSalaries($this, items[i]);
                }
            }
static addSalaries = ($this, item) => {
                if ($this.Salaries == null) $this.Salaries = [];
                if (item == null || $this.Salaries.indexOf(item) > -1) return;
                $this.Salaries.push(item);
}
static addRangeSalaries = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollContributionDetail.addSalaries($this, item));
            }
static removeSalaries = ($this, item) => {
                if ($this == null || $this.Salaries == null || $this.Salaries.indexOf(item) === -1) return;
                var _index = $this.Salaries.indexOf(item);
                $this.Salaries.splice(_index, 1);
}
static clearSalaries = ($this) => { $this.Salaries = null; }

static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}